/**
 * Document slots shown on the vehicle sheet.
 *
 * WHY THESE ARE KEYS AND NOT STRINGS
 * ----------------------------------
 * This file used to call `i18n.t()` at module scope:
 *
 *   title: i18n.t("panel.document.greyCard", "Grey card"),
 *
 * A module-level array literal is evaluated ONCE, when the bundle imports it
 * - before the user has ever touched the language switch, and never again
 * afterwards. So the three titles were frozen in whatever language i18next
 * happened to resolve at startup, and an English session kept rendering
 * "CONTRAT SIGNÉ (PDF)", "CARTE GRISE", "ASSURANCE".
 *
 * The tell was on the same screen: the Mileage panel beside it built its rows
 * from a FUNCTION called during render, and its labels translated correctly.
 * Same helper, same keys, different evaluation time.
 *
 * Titles are therefore stored as key + English fallback and resolved by the
 * component's own `t()` at render. Same convention as
 * containers/Sidebar/DataSideBar.ts.
 */
export type VehicleDocumentSlot = {
  id: string;
  icoName: string;
  titleKey: string;
  titleDefault: string;
};

export const dataDocuments: VehicleDocumentSlot[] = [
  {
    id: "1",
    icoName: "license",
    // This entry is an uploaded PDF, NOT the rent_contract record that gates
    // vehicle assignment. Both were labelled "CONTRAT" on the same screen, so
    // a vehicle showing "CONTRAT / Uploaded" and "3/3" still failed assignment
    // with "No contract attach to the vehicle", and the error read as a bug.
    // The record is labelled "Rental contract" (panel.vehicule.contract).
    titleKey: "panel.document.signedContract",
    titleDefault: "Signed contract (PDF)",
  },
  {
    id: "2",
    icoName: "cards",
    titleKey: "panel.document.greyCard",
    titleDefault: "Registration document",
  },
  {
    id: "3",
    icoName: "shieldCheck",
    titleKey: "panel.document.insurance",
    titleDefault: "Insurance",
  },
];
